<!--
  TODO : 댓글 공통 모듈
-->
<template>
  <el-drawer
    ref="comment-drawer"
    class="comment-drawer"
    title=""
    direction="btt"
    size="70%"
    :show-close="false"
    :visible.sync="drawer"
    :before-close="handleClose"
    @opened="opened">
    <div class="row">
      <!-- 입력란 -->
      <div v-if="!commentsDisabled" class="col-12">
        <q-editor
          v-model="editorComment"
          ref="editorRef"
          placeholder="댓글을 작성해주세요."
          max-height="150px"
          content-class="bg-amber-3"
          toolbar-text-color="white"
          toolbar-toggle-color="yellow-8"
          toolbar-bg="primary"
          :toolbar="[
            ['bold', 'italic', 'underline'],
            ['image'],
            ['save', 'close'],
          ]"
        >
          <template v-slot:image>
            <q-btn 
              v-if="!commentsDisabled" 
              flat round 
              size="9px"
              color="white" 
              icon="photo"
              @click="insertImg('I')">
              <q-tooltip>
                이미지 넣기
              </q-tooltip>
            </q-btn>
          </template>
          <template v-slot:save>
            <q-btn 
              v-if="!commentsDisabled" 
              flat round 
              size="9px"
              color="white" 
              icon="post_add"
              label="댓글 게시"
              @click="saveComments()">
              <q-tooltip>
                댓글 게시
              </q-tooltip>
            </q-btn>
          </template>
          <template v-slot:close>
            <q-btn 
              flat round 
              size="9px"
              color="white" 
              icon="close"
              @click="closeComments()">
              <q-tooltip>
                댓글창 닫기
              </q-tooltip>
            </q-btn>
          </template>
        </q-editor>
      </div>
      <!-- 댓글 -->
      <div class="col-12">
        <q-list 
          v-if="comments && comments.length > 0" 
          class="comments-list"
          ref="comments-list">
          <q-virtual-scroll
            style="max-height: 400px;"
            :items="comments"
            separator
          >
            <template v-slot="{ item, index }">
              <q-item :key="index" dense>
                <q-item-section>
                  <q-item-label>
                    <q-chip color="teal" text-color="white" icon="face">
                      {{item.regUserName}}
                    </q-chip>
                  </q-item-label>
                  <q-item-label caption class="comments-area">
                    <span v-if="!item.edit" v-html="item.comments" />
                    <!-- 수정모드 -->
                    <q-editor
                      v-else
                      v-model="item.comments"
                      max-height="80px"
                      content-class="bg-amber-3"
                      toolbar-text-color="white"
                      toolbar-toggle-color="yellow-8"
                      toolbar-bg="primary"
                      :toolbar="[
                        ['bold', 'italic', 'underline'],
                        ['image'],
                        ['save'],
                      ]"
                    >
                      <template v-slot:image>
                        <q-btn 
                          flat round 
                          size="9px"
                          color="white" 
                          icon="photo"
                          @click="insertImg('U', item)">
                          <q-tooltip>
                            이미지 넣기
                          </q-tooltip>
                        </q-btn>
                      </template>
                      <template v-slot:save>
                        <q-btn 
                          v-if="!commentsDisabled" 
                          flat round 
                          size="9px"
                          color="white" 
                          icon="upload_file"
                          label="댓글 수정"
                          @click="saveComments(item.sysCommentsId, item.comments)" />
                      </template>
                    </q-editor>
                  </q-item-label>
                </q-item-section>

                <q-item-section side top>
                  <q-item-label caption>{{item.regDtStr}}</q-item-label>
                  <div style="height: 40px;">
                    <q-btn 
                      v-if="item.regFlag && !commentsDisabled" 
                      flat round 
                      size="15px"
                      icon="delete" 
                      color="negative"
                      @click="deleteComments(item.sysCommentsId)">
                      <q-tooltip>
                        댓글 지우기
                      </q-tooltip>
                    </q-btn>
                    <q-btn 
                      v-if="item.regFlag && !commentsDisabled && !item.edit" 
                      flat round 
                      size="15px"
                      icon="edit" 
                      color="blue"
                      @click="editComments(item)">
                      <q-tooltip>
                        댓글 수정하기
                      </q-tooltip>
                    </q-btn>
                    <q-btn 
                      v-if="item.regFlag && !commentsDisabled && item.edit" 
                      flat round 
                      size="15px"
                      icon="refresh" 
                      color="grey"
                      @click="cancelComments(item)">
                      <q-tooltip>
                        댓글 수정취소
                      </q-tooltip>
                    </q-btn>
                  </div>
                </q-item-section>
              </q-item>
            </template>
          </q-virtual-scroll>
        </q-list>
        <q-list v-else bordered padding>
          <q-item>
            <q-item-section>
              <q-item-label overline class="non-comments">❌ 등록된 댓글이 없습니다. ❌</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
        <!-- <el-empty :image-size="200" description="등록된 댓글이 없습니다."></el-empty> -->
      </div>
    </div>
  </el-drawer>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  /* attributes: name, components, props, data */
  name: 'c-comments',
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    commentsInfo: {
      type: Object,
      default: function() {
        return {
          taskClassCd: '',
          taskKey: '',
        }
      }
    },
  },
  data() {
    return {
      drawer: false,
      editorComment: '',
      comments: [],
      listUrl: '',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
    };
  },
  computed: {
    commentsDisabled() {
      return !this.editable || this.disabled
    },
    searchParam() {
      return {
        taskClassCd: this.commentsInfo.taskClassCd,
        taskKey: this.commentsInfo.taskKey,
        regUserId: this.$store.getters.user.userId
      }
    },
  },
  watch: {
    value() {
      this.drawer = this.value
    },
    'commentsInfo.taskClassCd'() {
      this.getComments();
    },
    'commentsInfo.taskKey'() {
      this.getComments();
    },
  },
  /* Vue lifecycle: created, mounted, destroyed, etc */
  beforeMount() {
    this.init();
  },
  mounted() {
  },
  /* methods */
  methods: {
    init() {
      // url setting
      this.listUrl = selectConfig.com.comments.list.url;
      this.insertUrl = transactionConfig.com.comments.insert.url
      this.updateUrl = transactionConfig.com.comments.update.url
      this.deleteUrl = transactionConfig.com.comments.delete.url
      // list setting
      this.getComments();
    },
    getComments() {
      if (!this.commentsInfo.taskClassCd || !this.commentsInfo.taskKey) {
        this.comments = [];
        return
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.$set(this.$data, 'comments', _result.data)
      },);
    },
    insertImg(flag, item) {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.png, .jpg, .gif'
      let file
      input.onchange = () => {
        const files = Array.from(input.files)
        file = files[0]
        const reader = new FileReader()
        let dataUrl = ''
        reader.onloadend = () => {
          dataUrl = reader.result
          if (flag === 'I') {
            this.editorComment += '<div><img style="max-width: 400px;" src="' + dataUrl + '" /></div>' 
          } else {
            item.comments += '<div><img style="max-width: 400px;" src="' + dataUrl + '" /></div>' 
          }
        }
        reader.readAsDataURL(file)
      }
      input.click()
    },
    saveComments(sysCommentsId, comments) {
      if (!sysCommentsId ? !this.editorComment : !comments) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '글이 작성되지 않았습니다.', // 글이 작성되지 않았습니다.
          type: 'warning', // success / info / warning / error
        });
        return;
      }

      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '게시하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = (!sysCommentsId ? this.insertUrl : this.updateUrl);
          this.$http.type = (!sysCommentsId ? 'POST' : 'PUT');
          this.$http.param = {
            sysCommentsId: (sysCommentsId ? sysCommentsId : ''),
            taskClassCd: this.commentsInfo.taskClassCd,
            taskKey: this.commentsInfo.taskKey,
            comments: (!sysCommentsId ? this.editorComment : comments),
            regUserId: this.$store.getters.user.userId
          };
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.opened();
            this.getComments();
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });

    },
    deleteComments(sysCommentsId) {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, sysCommentsId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.getComments();
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    editComments(co) {
      this.$set(co, 'edit', true)
      this.$set(co, 'beforeComments', co.comments)
      co.edit = true;
    },
    cancelComments(co) {
      if (co.beforeComments !== co.comments) {
        this.$set(co, 'comments', co.beforeComments)
      }
      this.$set(co, 'edit', false)
    },
    handleClose(done) {
      this.$emit('input', false)
      done();
    },
    opened() {
      this.$set(this.$data, 'editorComment', '')
      this.$refs['editorRef'].focus();
    },
    closeComments() {
      this.$refs['comment-drawer'].closeDrawer();
    }
  },
};
</script>
<style lang="sass">
.comment-drawer
  .el-drawer__header
    margin: 0
    padding: 5px 20px 0
    font-size: 1.3em
    font-weight: 700
    background-color: #4CAF50
    color: white
  .q-editor__toolbar-group:last-child
    margin-left: auto
    .q-btn
      font-size: 13px !important

.non-comments
  font-size: 1.1em
  font-weight: 700
  text-align: center

.comments-list
  overflow-y: auto
  height: 400px

.comments-area
  margin-left: 10px
  color: black
</style>
